(() => {
  if (window.mpEditorialV5) return;
  window.mpEditorialV5 = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const tracked = new Map();
  const sync = (video, state) => {
    state.button.setAttribute('aria-label', video.paused ? state.button.dataset.playLabel : state.button.dataset.pauseLabel);
    state.button.textContent = video.paused ? '▶' : 'Ⅱ';
    state.button.setAttribute('aria-pressed', String(!video.paused));
  };
  const start = (video) => { const result = video.play(); if (result) result.catch(() => {}); };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = tracked.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      if (state.visible && !state.paused && !reduced.matches && state.auto) start(entry.target);
      else if (!state.visible) entry.target.pause();
    });
  }, { threshold: 0.15 });
  const init = (scope) => {
    scope.querySelectorAll('[data-mpe] video').forEach(video => {
      if (tracked.has(video)) return;
      const button = video.closest('.mpe-media').querySelector('[data-mpe-video-toggle]');
      if (!button) return;
      const section = video.closest('[data-mpe]');
      const state = { button, auto: section.dataset.autoplay === 'true', paused: false, visible: false };
      tracked.set(video, state);
      video.controls = false;
      button.hidden = false;
      video.addEventListener('play', () => sync(video, state));
      video.addEventListener('pause', () => sync(video, state));
      button.addEventListener('click', () => {
        state.paused = !video.paused;
        if (video.paused) start(video); else video.pause();
      });
      sync(video, state);
      observer.observe(video);
    });
  };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('video').forEach(video => { video.pause(); observer.unobserve(video); tracked.delete(video); });
  });
  reduced.addEventListener('change', () => { if (reduced.matches) tracked.forEach((state, video) => video.pause()); });
  document.addEventListener('visibilitychange', () => {
    tracked.forEach((state, video) => {
      if (document.hidden) video.pause();
      else if (state.visible && state.auto && !state.paused && !reduced.matches) start(video);
    });
  });
  let frame = 0;
  let point = { x: 0, y: 0 };
  document.addEventListener('pointermove', event => {
    if (event.pointerType !== 'mouse' || reduced.matches) return;
    point = { x: event.clientX, y: event.clientY };
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      document.querySelectorAll('[data-mpe-coordinates]').forEach(widget => {
        const box = widget.getBoundingClientRect();
        if (box.bottom <= 0 || box.top >= innerHeight || !box.width) return;
        widget.querySelector('[data-mpe-x]').textContent = String(Math.round(point.x));
        widget.querySelector('[data-mpe-y]').textContent = String(Math.round(point.y));
        const angle = Math.atan2(point.y - box.top - box.height / 2, point.x - box.left - box.width / 2) * 180 / Math.PI + 45;
        widget.querySelector('.mpe-footer-coordinate-arrow').style.transform = `rotate(${angle}deg)`;
      });
    });
  }, { passive: true });
  init(document);
})();
